import React from "react";
import { FormControl, FormErrorMessage, FormLabel, FormHelperText } from "@chakra-ui/react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
const Phone = ({ options, formik }) => {
	const styleClasses = options.styleClasses.length ? options.styleClasses.join(" ") : "";
	const hasError = formik.touched.phone && formik.errors.phone;
	return (
		<FormControl
			className={styleClasses}
			isInvalid={hasError ? true : false}
			mb="2"
			isRequired={options.isRequired}
		>
			{options.showLabel && (
				<FormLabel htmlFor="phone" fontSize="14px">
					{options.label}
				</FormLabel>
			)}

			<PhoneInput
				id="phone"
				name="phone"
				country={options.countryCode.toLowerCase()}
				onChange={(phone) => formik.setFieldValue("phone", phone)}
				onBlur={formik.handleBlur}
				value={formik.values.phone}
			/>
			<FormHelperText>{options.helpText}</FormHelperText>
			{hasError ? <FormErrorMessage>{formik.errors.phone}</FormErrorMessage> : null}
		</FormControl>
	);
};

export default Phone;
